import { PlanType } from '../../../types/plan.type';

export const getPriorityColor = (priority: number) => {
    switch (priority) {
        case 1:
            return 'green';
        case 2:
            return 'blue';
        case 3:
            return 'orange';
        case 4:
            return 'red';
        default:
            return 'gray';
    }
};

export const getServiceType = (type: number) => {
    switch (type) {
        case 1:
            return 'Básico';
        case 2:
            return 'Premium';
        case 3:
            return 'Empresarial';
        default:
            return 'Personalizado';
    }
};

export const getPlanTypeParsed = (type: PlanType) => {
    switch (type) {
        case 'one_time':
            return 'Una vez';
        case 'recurring':
            return 'Recurrente';
        case 'recurring_licensed':
            return 'Recurrente licenciado';
        default:
            return 'N/A';
    }
};
